import { render, staticRenderFns } from "./claimHis.vue?vue&type=template&id=5de4a30e&scoped=true"
import script from "./claimHis.vue?vue&type=script&lang=js"
export * from "./claimHis.vue?vue&type=script&lang=js"
import style0 from "./claimHis.vue?vue&type=style&index=0&id=5de4a30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4a30e",
  null
  
)

export default component.exports